import { render, staticRenderFns } from "./PlayerCreditsReceived.vue?vue&type=template&id=28209154&scoped=true&"
import script from "./PlayerCreditsReceived.vue?vue&type=script&lang=js&"
export * from "./PlayerCreditsReceived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28209154",
  null
  
)

export default component.exports